<template>
    <div class="container-fluid">
        <div class="row">
          <div class="col text-start">
            <vue-excel-xlsx class="btn btn-outline-secondary btn-sm mb-2" title="Download Excel File(รายชื่อลูกค้าและยอดรอเรียกชำระ)"
              :data="datalists"
              :columns="columns"
              :filename="'billing_cust_list'"
              :sheetname="'sheetname'"
              >
              Download
            </vue-excel-xlsx>
          </div>
        </div>
        <div class="row">
            <div class="col-sm-8 bg-light border py-2">
                <table id="myRepTable" class="table table-striped table-hover table-bordered table-sm" style="width: 100%;">
                    <thead class="text-dark" style="background:NavajoWhite">
                    <tr>
                        <th style="width:50px;">รหัสลูกค้า</th>
                        <th style="width:150px;">ชื่อลูกค้า</th>
                        <th style="width:300px;">ที่อยู่</th>
                        <th style="width:80px;">โทร.</th>
                        <th style="width:40px;">จำนวนรายการ</th>
                        <th style="width:50px;">จำนวนเงิน</th>
                        <th style="width:50px;">ส่วนลด</th>
                        <th style="width:50px;">ภาษีมูลค่าเพิ่ม</th>
                        <th style="width:50px;">จำนวนเงินสุทธิ</th>
                        <th style="width:60px;">พิมพ์</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!-- <tr v-for="item in datalists" :key="item.itemtestid" v-bind:data-id="item.ItemTestID"  @click="tableChanged(item)"> -->
                    <tr v-for="item in datalists" :key="item.ReqClinicID" @click="tableChanged(item)">
                        <td class="text-start">{{ item.ReqClinicCode }}</td>
                        <td class="text-start">{{item.ReqClinicName}}</td>
                        <td class="text-start">{{item.Addr1}} {{item.Tambon}} {{item.Amphor}} {{item.Province}} {{item.PostCode}}</td>
                        <td class="text-start">{{ item.Tel1 }}</td>
                        <td class="text-center">{{ item.CountLN }}</td>
                        <td class="text-end">{{ numeralFormat(item.SumTotalAmt, '0,0[.]00') }}</td>
                        <td class="text-end">{{ numeralFormat(item.SumDiscAmt, '0,0[.]00') }}</td>
                        <td class="text-end">{{ numeralFormat(item.SumVatAmt, '0,0[.]00') }}</td>
                        <td class="text-end">{{ numeralFormat(item.SumNetAmt, '0,0[.]00') }}</td>
                        <td>
                        <button class="btn btn-warning btn-sm me-1" @click="printReport(item)" id="Print">พิมพ์</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-sm">
                <RBillNote2LNView  :datalists="reportDtl" :key="countRefresh_LNView"
                :seleReqClinic="seleReqClinic"
                ></RBillNote2LNView>
            </div>
        </div>
    </div>

    <div id="divToPrint" hidden>
      <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
          <thead>
          <tr>
              <th style="width:90px;">เอกสารเลขที่</th>
              <th style="width:80px;">วันที่เอกสาร</th>
              <th style="width:200px;">คนไข้</th>
              <th style="width:70px; text-align: right;">จำนวนเงิน</th>
              <th style="width:50px; text-align: right;">ส่วนลด</th>
              <th style="width:40px; text-align: right;">VAT</th>
              <th style="width:70px; text-align: right;">สุทธิ</th>
          </tr>
          </thead>
          <tbody>
          <!-- <tr v-for="item in datalists" :key="item.itemtestid" v-bind:data-id="item.ItemTestID"  @click="tableChanged(item)"> -->
          <tr v-for="item in reportDtl" :key="item.ROID">
              <td style="text-align: center;">{{ item.RONo }}</td>
              <td style="text-align: left;">{{item.DocDate}}</td>
              <td style="text-align: left;">{{ item.PrefixName }}{{ item.PatName }} {{ item.PatLName }}</td>
              <td style="text-align: right;">{{formatFloat(item.TotalAmt)}}</td>
              <td style="text-align: right;">{{formatFloat(item.DiscAmt)}}</td>
              <td style="text-align: right;">{{formatFloat(item.VatAmt)}}</td>
              <td style="text-align: right;">{{formatFloat(item.NetAmt)}}</td>
          </tr>
          </tbody>
      </table>
      <table style="width:100%"  data-pdfmake="{'layout':'lightHorizontalLines'}">
        <thead>
          <tr>
            <th style="width:140px; text-align: right;" colspan="3">รวม</th>
            <th style="width:80px; text-align: left;"> </th>
            <th style="width:200px; text-align: left;"> </th>
            <th style="width:70px; text-align: right;">{{formatFloat(reportHd.SumTotalAmt)}}</th>
            <th style="width:50px; text-align: right;">{{formatFloat(reportHd.SumDiscAmt)}}</th>
            <th style="width:40px; text-align: right;">{{formatFloat(reportHd.SumVatAmt)}}</th>
            <th style="width:70px; text-align: right;">{{formatFloat(reportHd.SumNetAmt)}}</th>
          </tr>
        </thead>
      </table>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'jquery/dist/jquery.min.js'
// Datatable Modules
// import 'datatables.net-dt/js/dataTables.dataTables'
// import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'
// import JsBarcode from 'jsbarcode/bin/JsBarcode'
// import { bahttext } from 'bahttext'

import RBillNote2LNView from './RBillNote2LNView.vue'

import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}
// ----- จัด Format จำนวนเงิน ----- //
const { FormatMoney } = require('format-money-js')
const fm = new FormatMoney({
  decimals: 2
})

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'RepLabStatus',
  components: {
    RBillNote2LNView
  },
  data () {
    return {
      columns: [
        { label: 'รหัสคลินิก', field: 'ReqClinicCode' },
        { label: 'ชื่อคลินิก', field: 'ReqClinicName' },
        { label: 'ที่อยู่', field: 'FullAddr' },
        { label: 'โทร', field: 'Tel1' },
        { label: 'จำนวนเงิน', field: 'SumTotalAmt' },
        { label: 'ส่วนลด', field: 'SumDiscAmt' },
        { label: 'VAT', field: 'SumVatAmt' },
        { label: 'สุทธิ', field: 'SumNetAmt' },
        { label: 'จำนวนรายการ', field: 'CountLN' }
      ],
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],

      countRefresh_LNView: 0,
      seleReqClinic: '',
      reportHd: '',
      reportDtl: null
    }
  },
  props: ['datalists', 'branchSelected', 'dateFm', 'dateTo', 'statusSelectedText'],
  created () {

  },
  mounted () {
    // if (this.datalists !== null) {
    //   this.createA4PdfReportToScreen()
    // }
  },
  methods: {
    formatFloat (Amt) {
      return fm.from(parseFloat(Amt), { symbol: '' })
    },
    tableChanged (row) {
      this.seleReqClinic = row.ReqClinicName
      this.getLNNotPaidData(row)
    },
    getLNNotPaidData (row) {
      var self = this
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchSelected.BranchID // this.branchID
      MyApiClient.get('getdata/billnote_dtl_where_custid.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&CustID=' + row.ReqClinicID)
        .then((resp) => {
          // รายการ items ผลตรวจทั้งหมด
          self.reportDtl = resp.data.response
          this.countRefresh_LNView++
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getReportDtlData (row) {
      var self = this
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchSelected.BranchID // this.branchID
      MyApiClient.get('getdata/billnote_dtl_where_custid.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&CustID=' + row.ReqClinicID)
        .then((resp) => {
          // รายการ items ผลตรวจทั้งหมด
          self.reportDtl = resp.data.response
          this.$nextTick(() => self.createA4PdfReportToScreen())
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getReportData (row) {
      this.reportHd = row
      // ========================================= //
      // ดึง Detail ของใบสั่งตรวจ
      // ========================================= //
      this.getReportDtlData(row)
    },
    printReport (row) {
      console.log(row)
      // ดึงข้อมูลให้เสร็จก่อนแล้วค่อยสร้างรายงาน เรียกแบบ promise
      // A5GroupTest
      //    A5reportDtl
      this.getReportData(row)
    },
    // ----------- (1) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (General) ---------- //
    createA4PdfReportToScreen () {
      const textBranch = this.branchSelected.BranchName
      const textDateFm = this.dateFm.toISOString().substr(0, 10)
      const textDateTo = this.dateTo.toISOString().substr(0, 10)
      // ==================================== //
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [20, 170, 20, 30],
        header: {
          margin: [20, 10, 20, 10],
          table: {
            widths: [50, 210, 50, 210],
            body: [
              [
                {
                  colSpan: 4,
                  text: 'สรุปรายการรอเรียกเก็บเงิน\n' + self.globalCorpInfo.name + ' สาขา' + textBranch +
                    '\nระหว่างวันที่ ' + textDateFm + ' - ' + textDateTo,
                  bold: true,
                  fontSize: 16,
                  alignment: 'center',
                  margin: [0, 0, 0, 10],
                  lineHeight: 0.8,
                  border: [0, 0, 0, 0]
                },
                {},
                {},
                {}
              ],
              [
                // Header ซ้าย โลโก้คลินิก
                {
                  rowSpan: 4,
                  text: 'ผู้ออก',
                  width: 50,
                  alignment: 'left',
                  margin: [0, 0, 0, 0],
                  border: [1, 1, 0, 1]
                },
                // Header กลาง ชื่อคลินิก
                {
                  text: self.globalCorpInfo.InvcName,
                  bold: true,
                  fontSize: 16,
                  lineHeight: 0.5,
                  border: [0, 1, 0, 0]
                },
                // Header ด้านขวา ใบสั่งตรวจ
                {
                  rowSpan: 4,
                  text: 'ลูกค้า',
                  width: 50,
                  alignment: 'left',
                  border: [1, 1, 0, 1],
                  margin: [0, 0, 0, 0]
                },
                {
                  text: self.reportHd.ReqClinicName,
                  bold: true,
                  fontSize: 14,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.7,
                  border: [0, 1, 1, 0]
                }
              ],
              [
                {},
                {
                  text: self.globalCorpInfo.InvcName2,
                  bold: true,
                  fontSize: 12,
                  lineHeight: 0.5,
                  border: [0, 0, 0, 0]
                },
                {},
                {
                  text: self.reportHd.FullAddr,
                  bold: false,
                  fontSize: 12,
                  margin: [10, 0, 0, 0],
                  lineHeight: 0.7,
                  border: [0, 0, 1, 0]
                }
              ],
              [
                { },
                {
                  text: self.globalCorpInfo.InvcAddr1 + ' ' + self.globalCorpInfo.InvcAddr2 + ' ' + self.globalCorpInfo.InvcTambol + ' ' +
                        self.globalCorpInfo.InvcAmphor + ' ' + self.globalCorpInfo.InvcProvince + ' ' + self.globalCorpInfo.InvcZipcode + '\n' +
                        'Tel: ' + self.globalCorpInfo.InvcTel1 + ' ' + self.globalCorpInfo.InvcTel2 + ' Fax: ' + self.globalCorpInfo.InvcFax + '\n' +
                        'Email: ' + self.globalCorpInfo.InvcEmail1 + ' ' + self.globalCorpInfo.InvcEmail2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7
                },
                {
                  text: 'Tel: ' + self.reportHd.Tel1 + ' ' + self.reportHd.Tel2 +
                        'Email: ' + self.reportHd.Email1 + ' ' + self.reportHd.Email2,
                  bold: false,
                  fontSize: 12,
                  lineHeight: 0.7,
                  border: [0, 0, 1, 0]
                },
                {
                  text: '',
                  border: [0, 0, 1, 0]
                }
              ],
              [
                {
                  text: '',
                  border: [0, 0, 0, 1]
                },
                {
                  text: '',
                  width: 100,
                  alignment: 'left',
                  border: [0, 0, 0, 1],
                  margin: [0, 0, 0, 0]
                },
                {
                  text: '',
                  border: [0, 0, 0, 1]
                },
                {
                  text: '',
                  border: [0, 0, 1, 1]
                }
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          const d = new Date()
          const textDate = d.toISOString().substr(0, 19).replace('T', ' ')
          return {
            margin: [30, 0, 30, 10],
            table: {
              widths: [270, 150, 80],
              body: [
                // หมายเลขหน้า และวันที่พิมพ์
                [
                  {
                    text: 'Printed date : ' + textDate,
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        // content: 'TEST *******************',
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 16
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    }
  }
}
</script>

<style>

</style>
